export const CLASSNAME_HYPERLINK_BOX = 'xdHyperlinkBox';
export const CLASSNAME_DIALOG_INPUT_ROW = 'fv-dialog-input-row';
export const CLASSNAME_DIALOG_GUIDANCE = 'fv-dialog-guidance';
export const CLASSNAME_ERRMSG = 'err-msg';
export const CLASSNAME_HIDDEN = 'hidden';